import React, { useContext, useState, useEffect } from "react";
import ContextApi from "../../context/ContextApi";
import "../../stylesheet/forms.css";
import Arrow from "../../images/select-arrow.svg";
import MeetIcon from "../../images/google-meet.svg";
import ZoomIcon from "../../images/zoom.svg";
import ResponsibleDept from "./utils/ResponsibleDept";

export default function PatientAppointment(props) {


  const {
    setResponsibleDepartment, responsibleDepartment,
    setAssignedPersonnel,
    setAppointmentFrequency,
    setStartDate,
    startDate,
    setEndDate,
    endDate,
    setStartTime, startTime, assignedPersonnel,
    endTime, appointmentFrequency,
    setEndTime,
    setSessionType,
  } = useContext(ContextApi);

  const [apptType, setApptType] = useState("");
  const [dropdown, setDropdown] = useState(false);
  const [virtualDrop, setVirtualDrop] = useState(false);

  const toggleDropdown = () => {
    setDropdown(!dropdown);
    setVirtualDrop(false);
  };

  const result = (() => {
    if (apptType === "In person") {
      return apptType;
    } else if (apptType === "Virtual - Zoom") {
      return apptType;
    } else if (apptType === "Virtual - Google Meet") {
      return apptType;
    } else {
      return "Select type";
    }
  })();

  const toggleVirtualDropdown = () => {
    setVirtualDrop(!virtualDrop);
  };

  const InpersonType = () => {
    setApptType("In person");
    toggleDropdown();
  };

  const [checkboxareaVisibility, setCheckboxareaVisibility] = useState({
    question1: false,
    question2: false,
    question3: false,
  });

  useEffect(() => {
    if (localStorage.getItem('patientEditMode') === 'true') {

      setCheckboxareaVisibility({
        ...checkboxareaVisibility,
        question1: !!responsibleDepartment.length ?? true,
      })
    }
  }, [responsibleDepartment])

  const handleShowCheckboxarea = (questionId, status) => {
    setCheckboxareaVisibility({
      ...checkboxareaVisibility,
      [questionId]: status,
    });
  };

  return (
    <div className="font-euclid-circular-a h-[620px]">
      <div className="border border-gray-400 rounded w-full lg:w-[750px] h-[600px] lg:ml-[5%] mt-5 p-3">
        <h1 className="text-xl font-bold ml-3 mt-4 text-gray-600">
          Appointment & Delegation
        </h1>

        <div className="h-[450px] overflow-y-auto summary-steps mt-8">
          <form id="p-Appointment" className="lg:pl-9 lg:pr-9 ">
            <div className="flex flex-col">
              <label htmlFor="name" className="mb-2 ml-2">
                Responsible department
              </label>
              <div className="ml-3">
                <label htmlFor="responsibleDept" >Yes </label>
                <input type="radio"
                  id="responsibleDept"
                  name="question1"
                  value="true"
                  checked={checkboxareaVisibility.question1}
                  onChange={() => handleShowCheckboxarea('question1', true)}
                />
                <label className="ml-3" htmlFor="not-responsibleDept" > No </label>
                <input type="radio"
                  id="not-responsibleDept"
                  name="question1"
                  value="false"
                  checked={!checkboxareaVisibility.question1}
                  onChange={() => {
                    handleShowCheckboxarea('question1', false);
                    // setPreExistingCondition([])
                  }}
                />
              </div>

              {checkboxareaVisibility.question1 && (

                <ResponsibleDept preSelected={responsibleDepartment} selected={responsibleDepartment} ifAllergy={(data) => setResponsibleDepartment(data.filter((item) => item.status))} />
              )}
            </div>

            <div className="flex flex-col mt-4">
              <label htmlFor="name" className="mb-2 ml-2">
                Assigned personnel
              </label>
              <select
                value={assignedPersonnel}
                onChange={(e) => setAssignedPersonnel(e.target.value)} className="p-3 border rounded text-gray-500 focus:text-black">
                <option
                  selected
                >
                  Select answer
                </option>
                <option value="option1">option1</option>
                <option value="option2">option2</option>
                <option value="option3">option3</option>
                <option value="option4">option4</option>
              </select>
            </div>

            <div className="flex flex-col mt-4 capitalize">
              <label htmlFor="name" className="mb-2 ml-2">
                Appointment frequency
              </label>
              <select style={{ textDecorationLine: 'capitalize' }} value={appointmentFrequency} onChange={(e) => setAppointmentFrequency(e.target.value)} className="p-3 border rounded text-gray-500 focus:text-black capitalize">
                <option
                  selected
                >
                  Select answer
                </option>
                <option value={'daily'}>daily</option>
                <option value={'every 2 days'}>every 2 days</option>
                <option value={'weekly'}>weekly</option>
                <option value={'every 2 weeks'}>every 2 weeks</option>
                <option value={'monthly'}>monthly</option>
                <option value={'every 2 months'}>every 2 months</option>
                <option value={'quarterly'}>quarterly</option>
                <option value={'semiannually'}>semiannually</option>
                <option value={'annually'}>annually</option>
              </select>
            </div>
            <div className="flex mt-3 justify-between w-full gap-2 lg:gap-4">
              <div className="flex flex-col sm:w-1/2 w-full">
                <label htmlFor="name" className="mb-2 ml-2">
                  Start Date
                </label>
                <input
                  type="date"
                  defaultValue={startDate}
                  className="p-3 border text-gray-400 focus:text-black"
                  placeholder=" Enter value"
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>

              <div className="flex flex-col sm:w-1/2 w-full">
                <label htmlFor="name" className="mb-2 ml-2">
                  End Date
                </label>
                <input
                  defaultValue={endDate}
                  type="date"
                  className="p-3 border text-gray-400 focus:text-black "
                  placeholder=" Enter value"
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            </div>

            <div className="flex mt-3 justify-between w-full gap-2 lg:gap-4">
              <div className="flex flex-col sm:w-1/2 w-full">
                <label htmlFor="name" className="mb-2 ml-2">
                  Start Time
                </label>
                <input
                  defaultValue={startTime}
                  type="time"
                  className="p-3 border  text-gray-500 rounded"
                  placeholder=" Enter value"
                  onChange={(e) => { setStartTime(e.target.value) }}
                />
              </div>

              <div className="flex flex-col sm:w-1/2 w-full">
                <label htmlFor="name" className="mb-2 ml-2">
                  End Time
                </label>
                <input
                  defaultValue={endTime}
                  type="time"
                  className="p-3 w-full border text-gray-500 rounded"
                  placeholder=" Enter value"
                  onChange={(e) => setEndTime(e.target.value)}
                />
              </div>
            </div>

            <div className="flex flex-col mt-4">
              <label htmlFor="name" className="mb-2 ml-2">
                Appointment type
              </label>
              <div
                placeholder="Select type..."
                onClick={toggleDropdown}
                className="p-3 flex justify-between border rounded text-gray-500 focus:text-black cursor-pointer"
              >
                {result}
                {apptType.includes("Virtual") && <img src={Arrow} alt="" />}
              </div>

              {dropdown && (
                <div className="border rounded">
                  <div
                    onClick={InpersonType}
                    className="border p-2 cursor-pointer"
                  >
                    In person
                  </div>
                  <div
                    onClick={toggleVirtualDropdown}
                    className="border p-2 cursor-pointer flex justify-between relative"
                  >
                    Virtual
                    <img src={Arrow} alt="" />
                  </div>

                  {virtualDrop && (
                    <div className="border rounded w-[194px] absolute bottom-[17%] right-[22%]">
                      <div
                        onClick={() => {
                          setApptType("Virtual - Google Meet");
                          toggleDropdown();
                        }}
                        className="flex border border-gray-500 p-2 gap-7 bg-slate-100 cursor-pointer"
                      >
                        <img src={MeetIcon} alt="" /> Google Meet
                      </div>
                      <div
                        onClick={() => {
                          setApptType("Virtual - Zoom");
                          toggleDropdown();
                        }}
                        className="flex border border-gray-500 p-2 gap-8 bg-slate-100 cursor-pointer"
                      >
                        <img src={ZoomIcon} alt="" /> Zoom
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="mt-3 flex w-full justify-end">
              <button
                className="border-sky-600 border text-sky-500 mb-4 p-2 w-36 rounded"
                onClick={props.onBack}
              >
                Back
              </button>
              <button
                className="bg-sky-600 text-white mb-4 p-2 w-36 rounded ml-3"
                onClick={props.onContinue}
              >
                Continue
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
